import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.use(VueRouter)
Vue.config.ignoredElements = ["dnl-dwchart", "dnl-youtubeembed", "dnl-twitterembed", "dnl-wgchart", "dnl-addon"]

const router = new VueRouter({
  mode: "history",
  routes: [
    {path: "/", component:App}
  ]
})
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
